import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';
import InputRange from 'react-input-range';

class SlideInput extends React.Component {
    render()
    {
        const marginTop = this.props.marginTop;

        return(
            <Flex column className={style.InformationFormsWrapper} style={{marginTop: marginTop}} width='100%'>
                <InputRange
                    className={style.FormStyle}
                    type='number'
                    onChange={this.onChange}
                    {...this.props}
                    />
            </Flex>
        );
    }
}
export default SlideInput;



// WEBPACK FOOTER //
// ./src/component/Forms/SlideInput/index.js